<template>
    <v-container class="pa-0 mt-0">
        <v-layout row :wrap="!$bp.lgAndUp" mt-3>
            <!-- companies column -->
            <v-flex xs12 sm12 md12 lg4 style="align-self: flex-start">
                <v-layout column>
                    <v-flex pb-0>
                        <v-toolbar elevation="0" flat>
                            <v-toolbar-title class="ml-0">{{ $t("lang.companies") }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon @click="addCompanyToUserDialog = true">
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.addCompany") }}
                            </bc-tooltip>
                        </v-toolbar>
                    </v-flex>
                    <bc-search-list
                        :items="person.user.accounts"
                        :selected_id="currentCompanyId"
                        :filter="searchFilter"
                        :clickMethod="setCurrentCompany"
                        item-value="company_id"
                        item-text="company"
                        height="410px"
                        :emptyMessage="person.slug == 'employee' ? $t('lang.all_companies') : component_loader ? $t('lang.loading') : $t('lang.no_companies')"
                    ></bc-search-list>
                    <!-- <v-flex
                        class="text-center grey--text"
                        :class="person.login_type == 'employee' ? 'title grey lighten-2 mt-2' : 'mt-4'"
                        v-if="person.user.accounts && person.user.accounts.length == 0"
                    >
                        {{ person.login_type == "employee" ? $t("lang.all_companies") : component_loader ? $t("lang.loading") : $t("lang.no_companies") }}
                    </v-flex> -->
                </v-layout>
            </v-flex>
            <v-divider vertical v-if="$bp.lgAndUp"></v-divider>
            <!-- permissions column -->
            <v-flex xs12 sm12 md12 lg8 style="align-self: flex-start">
                <v-layout column>
                    <v-flex pb-0>
                        <v-toolbar elevation="0" flat>
                            <v-toolbar-title class="ml-0">{{ $t("lang.permissions") }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-menu :disabled="allPermissions != null ? false : true">
                                <template slot="activator">
                                    <v-btn icon :v-readonly-click="allPermissions != null ? false : true" :disabled="allPermissions != null ? false : true">
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-tile v-for="(item, index) in menu_items" :key="index" @click="menuController(item)">
                                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </v-toolbar>
                    </v-flex>
                    <v-flex pt-0 :class="{ 'prevent-click': !allow_perms }">
                        <div class="mt-2">
                            <v-flex class="text-center grey--text mt-0" v-if="allPermissions == null">
                                {{ component_loader ? $t("lang.loading") : $t("lang.select_company") }}
                            </v-flex>
                            <vue-perfect-scrollbar
                                v-else
                                class="scroll-area search_list"
                                :style="$bp.xs ? null : 'height: calc(100vh - 375px); overflow-y: auto'"
                            >
                                <v-flex
                                    v-for="(mod, index) in returnFilteredPerms"
                                    style="overflow: hidden"
                                    class="py-0"
                                    :key="index"
                                    :px-0="$bp.smallScreen"
                                    :class="[
                                        !$bp.smallScreen && allow_perms ? 'hoverable' : '',
                                        index != returnFilteredPerms.length - 1 ? 'border-bottom-1' : '',
                                    ]"
                                >
                                    <v-layout :column="$bp.smallScreen">
                                        <v-flex
                                            xs4
                                            class="my-auto pr-0"
                                            :pt-4="$bp.smallScreen"
                                            :pb-0="$bp.smallScreen"
                                            :class="$bp.smallScreen ? 'pl-2' : 'pl-1'"
                                        >
                                            <b>{{ mod.module | start_case }}</b>
                                        </v-flex>
                                        <v-flex xs8 :class="$bp.smallScreen ? 'pt-0 pb-1' : 'py-1'">
                                            <bc-autocomplete
                                                v-model="updatedPermissions[mod.module_id]"
                                                :items="allPermissionsFiltered[mod.module_id]"
                                                item-value="value"
                                                item-text="text"
                                                :label="$t('lang.edit_permissions')"
                                                class="ma-0 pa-0"
                                                multiple
                                                @change="checkIfChanged()"
                                                chips
                                                no-data-text="No data to show"
                                                hide-details
                                                single-line
                                                full-width
                                                :readonly="!allow_perms"
                                            >
                                                <template slot="prepend-item">
                                                    <v-flex d-flex style="justify-content: flex-end; align-items: flex-end">
                                                        <v-btn @click="selectAll(mod)" color="primary"
                                                            ><v-icon>{{
                                                                toggleAllModules.indexOf(mod.module_id) > -1 ? "check_box" : "check_box_outline_blank"
                                                            }}</v-icon
                                                            ><span class="ml-2 fw-bold">Toggle All</span></v-btn
                                                        >
                                                    </v-flex>
                                                </template>
                                                <template slot="selection" slot-scope="data">
                                                    <v-chip :selected="data.selected" color="black" outline class="chip--select-multi chip-break-word">
                                                        <v-list-tile-content>
                                                            <v-list-tile-title style="max-width: 250px">{{ data.item.text }}</v-list-tile-title>
                                                        </v-list-tile-content>
                                                    </v-chip>
                                                </template>
                                            </bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </vue-perfect-scrollbar>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <!-- pop up dialogs -->
        <bc-dialog :value="applyTemplateDialog" max-width="500">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.apply_template") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="applyTemplateDialog"
                        :dialog-status="applyTemplateDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-form>
                        <v-layout row wrap>
                            <v-flex>
                                <bc-autocomplete
                                    v-if="login_types != null"
                                    v-model="login_type"
                                    :items="login_types"
                                    item-text="login_type"
                                    item-value="login_type_id"
                                    :label="$t('lang.select_login_type_base')"
                                    class="pt-0"
                                >
                                    <template slot="item" slot-scope="data">
                                        {{ $t(`lang.${data.item.login_type}`) }}
                                    </template>
                                    <template slot="selection" slot-scope="data">
                                        {{ $t(`lang.${data.item.login_type}`) }}
                                    </template>
                                </bc-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flate @mouseup.left="applyTemplateDialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="applyTemplate()">{{ $t("lang.apply") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="addCompanyToUserDialog" max-width="500">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t("lang.addCompany") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="addCompanyToUserDialog"
                        :dialog-status="addCompanyToUserDialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form v-model="valid" ref="addCompanyToUser" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-if="companies != null"
                                        :focus="addCompanyToUserDialog"
                                        v-model="companyToAdd"
                                        :label="$t('lang.select_a_company')"
                                        :items="returnFilteredCompanies"
                                        item-text="company"
                                        item-value="company_id"
                                        :rules="ifValid('user.company_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <p class="mb-2">{{ $t("lang.is_owner") }}</p>
                                    <v-radio-group v-model="isOwner" row class="mt-0" :rules="ifValid('user.owner')">
                                        <v-radio label="Yes" value="1"></v-radio>
                                        <v-radio label="No" value="0"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="addCompanyToUserDialog = false">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="addCompany()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="removeCompanyDialog"
            :message="$t('lang.confirm_remove_beginning') + currentCompanyName + $t('lang.confirm_remove_end')"
            :heading="$t('lang.removeCompany')"
            @onConfirm="removeCompany()"
        ></delete-confirmation-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
    name: "user_permissions",
    props: {
        hasPerms: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            companies: null,
            currentCompany: {},
            isOwner: null,
            allCompanies: null,
            companyToAdd: null,
            component_loader: false,
            currentPermissions: [],
            allPermissions: null,
            allPermissionsFiltered: [],
            addCompanyToUserDialog: false,
            removeCompanyDialog: false,
            applyTemplateDialog: false,
            currentCompanyId: null, //TODO: no need to assign separate variables
            currentCompanyName: null,
            updatedPermissions: {},
            toggleAllModules: [],
            changed: true,
            permsToWatch: {},
            valid: false,
            settings: {
                maxScrollbarLength: 150,
            },
            companies_body: {
                user_id: null,
            },
            scrollBarHeight: "",
            login_type: "",
            menu_items: [{ title: this.$t("lang.apply_template") }, { title: this.$t("lang.remove_company") }],
            get_timer: null,
            allow_perms: true,
            searchFilter: "",
        };
    },

    async activated() {
        await this.$store
            .dispatch("fetchUsers", {
                url: `users/${this.person.user_id}`,
                method: "get",
                headers: { "X-SILENT": "1" },
            })
            .then((data) => {
                this.$store.commit("updateUserObject", data.user);
            });
        this.allPermissions = null;
        if (
            this.personHasLoginType(this.person, ["employee", "customer_support", "administrator", "developer"]) &&
            this.allPermissions == null &&
            this.person.user.accounts.length == 0
        ) {
            this.getModules({ company_id: null });
        }
        this.fetchCompanies({ body: { options: 1, minimal: 1 } }).then((data) => {
            this.companies = data.companies;
        });
        this.allow_perms = this.hasPerms && this.hasPerm("people.update") && this.hasPerm("permissions.update");
    },
    deactivated() {
        this.allPermissions = null;
    },
    computed: {
        ...mapState({
            rules_user: (state) => state.validation.rules_user,
            person: (state) => state.people.selectedPerson,
        }),
        ...mapGetters(["person", "login_types", "update_permissions", "undo_permissions"]),
        returnFilteredPerms() {
            if (this.allPermissions != null) {
                //return a new array with only the permissions the user has
                this.allPermissions.forEach((mod, index) => {
                    if (mod.permission_functions) {
                        this.currentPermissions[index] = { ...mod };
                        this.currentPermissions[index].permission_functions = mod.permission_functions.filter((permission) => permission.has_permission == 1);
                    }
                });
                return this.currentPermissions;
            }
        },
        returnFilteredCompanies() {
            // iterate through the companies and return only the ones that are not already assigned to the user
            return this.companies.filter((company) => {
                return this.person.user.accounts.map((account) => account.company_id).indexOf(company.company_id) == -1;
            });
        },
    },
    watch: {
        update_permissions() {
            if (this.update_permissions == true) {
                this.updatePermissions();
            }
        },
        undo_permissions() {
            if (this.undo_permissions == true) {
                this.undoPermissionChanges();
            }
        },
    },
    methods: {
        ...mapActions([
            "fetchCustomers",
            "fetchVendors",
            "fetchDistributors",
            "assignUserToCompany",
            "removeUserFromCompany",
            "fetchCompanies",
            "fetchDevices",
            "fetchTags",
        ]),
        ...mapMutations(["mutatePermissionsChanged", "mutateUpdatePermissions", "mutateUndoPermissions"]),
        setCurrentCompany(company) {
            if (company && (this.currentCompanyId != company.company_id || !this.get_timer)) {
                clearTimeout(this.get_timer);
                this.currentCompany = company;
                this.currentCompanyId = company.company_id;
                this.currentCompanyName = company.company;
                this.getModules(company);
                this.get_timer = setTimeout(() => {
                    this.get_timer = null;
                }, 1500);
            }
        },
        menuController(item) {
            if (item.title == "Apply Template") {
                this.getTemplates();
            } else if (item.title == "Remove Company") {
                this.deleteCompany();
            }
        },
        applyTemplate() {
            //use the login type id to set the permissions
            this.startLoader();
            this.$nextTick(() => {
                this.$store
                    .dispatch("fetchModules", {
                        url: "modules/" + this.login_type + "/permission/templates",
                        method: "get",
                    })
                    .then((data) => {
                        this.allPermissions = data.permissions_template.filter((mod) => {
                            return mod.permission_functions;
                        });

                        let filteredArray = [];
                        this.allPermissions.forEach((mod) => {
                            if (mod.permission_functions) {
                                mod.permission_functions.forEach((permission) => {
                                    if (permission.user_functions_template) filteredArray.push(permission.function_id);
                                });
                                this.updatedPermissions[mod.module_id] = filteredArray.sort();
                            }
                            filteredArray = [];
                        });
                        this.checkIfChanged();
                        this.login_type = "";
                        this.finishLoader();
                        this.applyTemplateDialog = false;
                    });
            });
        },
        getLoginTypes() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchLoginType", {
                    url: "login_types",
                    method: "get",
                    stateProperty: "login_types",
                    dataProperty: "app_login_types",
                    commit: true,
                    localStorage: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getTemplates() {
            this.applyTemplateDialog = true;
            //get login types
            if (this.login_types == null) {
                this.getLoginTypes();
            }
        },
        checkIfChanged() {
            this.$nextTick(() => {
                for (const mod in this.updatedPermissions) {
                    this.updatedPermissions[mod].sort();
                }
                if (JSON.stringify(this.permsToWatch) === JSON.stringify(this.updatedPermissions)) {
                    this.$store.commit("mutatePermissionsChanged", false);
                } else {
                    this.$store.commit("mutatePermissionsChanged", true);
                }
            });
        },
        undoPermissionChanges() {
            this.updatedPermissions = JSON.parse(JSON.stringify(this.permsToWatch));
            this.changed = false;
            this.$store.commit("mutatePermissionsChanged", false);
            this.$store.commit("mutateUndoPermissions", false);
        },
        updatePermissions() {
            let body = {
                company_id: this.currentCompanyId,
                modules: [],
            };

            this.currentPermissions.filter(() => {
                return true;
            });

            for (const mod in this.updatedPermissions) {
                let updatedMod = {
                    module_id: mod,
                    function_id: this.updatedPermissions[mod],
                };

                body.modules.push(updatedMod);
            }
            this.component_loader = true;

            this.$store
                .dispatch("fetchUsers", {
                    url: "users/" + this.person.user_id + "/permissions",
                    method: "post",
                    body: body,
                })
                .then((data) => {
                    this.getModules(this.currentCompany);
                    this.component_loader = false;
                    this.changed = false;
                    this.$store.commit("mutatePermissionsChanged", false);
                    this.$store.commit("mutateUpdatePermissions", false);
                });
        },
        getUserCompanies() {
            this.component_loader = true;
            this.$store
                .dispatch("fetchCustomers", {
                    url: "customers?user_id=" + this.person.user_id,
                    method: "get",
                })
                .then((data) => {
                    this.companies = data.customers;
                    this.component_loader = false;
                    this.removeCompanyDialog = false;
                });
        },
        addCompany() {
            let company_body = {
                user_id: this.person.user_id,
                owner: this.isOwner,
            };
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("addCompanyToUser")) {
                    this.$store.commit("toggleModalLoader", true);
                    this.assignUserToCompany({ body: company_body, id: this.companyToAdd })
                        .then((data) => {
                            this.$store.commit("updateUserObject", data.user);
                            this.currentCompanyName = this.allPermissions = this.currentCompanyId = this.isOwner = null;
                            this.currentPermissions = [];
                            // this.companies.push(data.users); // add new company to the shown list of companies
                            let company_ids = this.person.user.accounts.map((account) => account.company_id);
                            let body = { company_id: company_ids, options: 1 };
                            this.fetchDevices({
                                body: body,
                            });
                            this.fetchTags({
                                body: body,
                            });
                        })
                        .finally(() => {
                            this.$refs.addCompanyToUser.reset();
                            this.addCompanyToUserDialog = false;
                            this.$store.commit("validationOff");
                            this.$store.commit("toggleModalLoader", false);
                        });
                }
            });
        },
        removeCompany() {
            this.$store.commit("toggleModalLoader", true);
            this.removeUserFromCompany({ id: this.currentCompanyId, user_id: this.person.user_id }).then((data) => {
                this.$store.commit("updateUserObject", data.user);
                this.allPermissions = null;
                this.$refs.removeCompanyDialog.close();
                this.$store.commit("toggleModalLoader", false);
                let company_ids = [];
                if (this.person.user.accounts) {
                    company_ids = this.person.user.accounts.map((account) => account.company_id);
                }
                if (company_ids.length > 0) {
                    let body = { company_id: company_ids, options: 1 };
                    this.fetchDevices({
                        body: body,
                    });
                    this.fetchTags({
                        body: body,
                    });
                } else {
                    this.$store.commit("mutate", {
                        property: "device_options",
                        with: [],
                    });
                    this.$store.commit("mutate", {
                        property: "tag_options",
                        with: [],
                    });
                }
            });
        },
        getModules(companyObj) {
            this.component_loader = true;
            this.changed = false;

            let modules_body = {
                user_id: this.person.user_id,
                company_id: companyObj.company_id,
            };

            this.$store
                .dispatch("fetchModules", {
                    url: "modules",
                    method: "get",
                    body: modules_body,
                })
                .then((data) => {
                    this.allPermissions = data.modules.filter((mod) => {
                        return mod.permission_functions;
                    });

                    let filteredArray = [];
                    this.allPermissions.forEach((mod) => {
                        this.allPermissionsFiltered[mod.module_id] = [];
                        if (mod.permission_functions) {
                            mod.permission_functions.forEach((permission) => {
                                this.allPermissionsFiltered[mod.module_id].push({ value: permission.function_id, text: permission.permission });
                                permission.has_permission == 1 ? filteredArray.push(permission.function_id) : null;
                            });
                            this.updatedPermissions[mod.module_id] = filteredArray.sort();
                        }
                        filteredArray = [];
                    });
                    this.permsToWatch = JSON.parse(JSON.stringify(this.updatedPermissions));
                })
                .finally(() => {
                    this.component_loader = false;
                });
        },
        deleteCompany() {
            this.$refs.removeCompanyDialog.openDialog();
        },
        getUser() {
            this.$store
                .dispatch("fetchUsers", {
                    url: `users/${this.person.user_id}`,
                    method: "get",
                    headers: { "X-SILENT": "1" },
                })
                .then((data) => {
                    this.$store.commit("updateUserObject", data.user);
                });
        },
        selectAll(module) {
            if (this.toggleAllModules.indexOf(module.module_id) == -1) {
                this.allPermissionsFiltered[module.module_id].forEach((permission) => {
                    if (this.updatedPermissions[module.module_id].indexOf(permission.value) == -1) {
                        this.updatedPermissions[module.module_id].push(permission.value);
                    }
                });
                this.toggleAllModules.push(module.module_id);
            } else {
                this.updatedPermissions[module.module_id].splice(0, this.updatedPermissions[module.module_id].length);
                this.toggleAllModules.splice(this.toggleAllModules.indexOf(module.module_id), 1);
            }
            this.checkIfChanged();
        },
    },
};
</script>
